<template>
    <div class="content-heading">
        <i class="ic-head-icon">
            <img src="@/assets/images/sidebar/rewards.svg" alt="Rewards Icon">
        </i>
        <h4 class="head-title">Rewards</h4>
        <i class="ic-tooltip" id="help"></i>
        <b-popover target="help"
                   triggers="hover"
                   content="These are the items/services that registered customers can redeem in exchange for the points that they have earned.">
        </b-popover>
        <div class="head-tabs">
            <b-nav tabs>
                <b-nav-item
                    :to="{ path: '/rewards/my-rewards'}" v-if="showNav({ permission: 'rewards.my-rewards', reward_version: 'v1' })">
                    My Rewards
                </b-nav-item>
                <b-nav-item :to="{ path: '/rewards/my-rewards-v2'}" v-if="showNav({ permission: 'rewards.my-rewards', reward_version: 'v2' })">
                    My Rewards
                </b-nav-item>
                <!--<b-nav-item :to="{ path: '/rewards/marketplace' }">
                    Marketplace
                </b-nav-item>-->
            </b-nav>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import permission from "../../services/user.permission";
export default {
    name: "rewards-nav",
    data() {
        return {
            msg: "Rewards Nav",
            permission: permission
        };
    },
    computed: {
        ...mapGetters({
            rewardVersion: "auth/rewardVersion",
            authLoading: "auth/loading"
        })
    },
    async created() {
        await this.getAdminSettings().then(() => {
            if (
                !this.rewardVersion.includes("v1") &&
                this.$route.name === "MyRewards"
            )
                this.$router.push({ name: "MyRewardsV2" });
        });
    },
    methods: {
        ...mapActions({
            getAdminSettings: "auth/getAdminSettings"
        }),
        showNav(params) {
            return (
                this.permission.hasAccess(params.permission) &&
                this.rewardVersion.includes(params.reward_version)
            );
        }
    }
};
</script>

<style scoped>
</style>
